import React from "react";
import UnsavedChangesModal from "@dhn/components/molecules/unsaved-changes-modal";

export default function ModalConfirmationEdit({
  isOpen,
  handleEndConsultation,
}) {
  return (
    <UnsavedChangesModal
      isOpen={isOpen}
      onContinueEditing={() =>
        handleEndConsultation({
          actionsFromModal: true,
          optionSelected: false,
        })
      }
      onDiscard={() =>
        handleEndConsultation({
          actionsFromModal: true,
          optionSelected: true,
        })
      }
      message="Tiene cambios pendientes. ¿Desea cerrar sin guardar?"
      hint="Si continúa, se perderán los cambios que aún no ha guardado."
      continueLabel="Seguir editando"
      discardLabel="Cerrar sin guardar"
    />
  );
}
